let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lUlCu")).then(() => parcelRequire('gI8uy'));